export const EditYourDetailsSentence = 'Edit your quote details';
export const AboutYourCover = "About your cover";
export const AboutYourProperty = "About your property";
export const AboutYou = "About you";
export const gtmEvent = "accordion_interaction";
export const AboutYouImage = "./assets/images/blue-backgrounds/Identity_Information.svg";
export const AboutYourPropertyImage = "./assets/images/blue-backgrounds/Circle_Semi-Detached House.svg";
export const AboutYouCoverImage = "./assets/images/blue-backgrounds/Circle_Clipboard_Home.svg";